export const ALERTS = 'alerts'
export const ALERTS_SOURCE = 'alerts'

export const ALERT_STATUS_OPEN = 1
export const ALERT_STATUS_CLOSE = 2
export const FILTER_ALERT_STATUS = [
  {id: ALERT_STATUS_OPEN, name: 'alerts.messages.open'},
  {id: ALERT_STATUS_CLOSE, name: 'common.messages.closed'},
]

export const ALERTS_TABLE_NAME = 'ALERTS_LIST'
